import React, { useState } from "react";
import { Calendar } from "primereact/calendar";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "src/Assets/css/ReusuableComponents/AutoCompleteTextField.css";
import "src/Assets/css/ReusuableComponents/CalendarComponent.css";
import styles from "src/Assets/css/home/post.module.css";
import CloseIcon from "@mui/icons-material/Close";
import calenderIcon from "src/Assets/images/Calendaricon.png";
import calenderBlueIcon from "src/Assets/images/Path 542 blue.png";
import { outlinedInputClasses } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import "./editCalendar.css";

function EditCalendarComponent(props) {
  const { setReminderDateAndTime, previousReminder } = props;
  const [selectedDateTime, setSelectedDateTime] = useState(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false); // Update state for tracking calendar open/close

  const handleDateTimeChange = (e) => {
    setSelectedDateTime(e.value);
    setReminderDateAndTime(e.value);
  };

  const changeCalenderState = () => {
    setIsCalendarOpen(!isCalendarOpen);
  };
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
      timeZone: "Asia/Kolkata",
    };

    // Format the date
    let formatted = date.toLocaleString("en-GB", options);

    // Ensure proper format (remove comma and ensure uppercase AM/PM)
    formatted = formatted.replace(",", "").toUpperCase();

    return formatted;
  };

  const header = () => (
    <div className={styles.calendarHeaderText}>
      {/* <p>Edit Reminder</p> */}
      {selectedDateTime ? (
        <p>{formatDate(selectedDateTime)}</p>
      ) : (
        <p>{previousReminder}</p>
      )}
    </div>
  );

  const currentDate = new Date();

  return (
    <div className="edit_calender">
      <div>
        <Calendar
          headerTemplate={header}
          value={selectedDateTime}
          onChange={handleDateTimeChange}
          showTime={true}
          hourFormat="12"
          dateFormat="dd-M-yy"
          baseZIndex={1051}
          inputStyle={{ display: "none" }}
          showIcon={true}
          minDate={currentDate}
          panelClassName="custom-calendar-popup"
          icon={
            <Tooltip title="Set Reminder" arrow>
            <img
              src={isCalendarOpen ? calenderBlueIcon : calenderIcon}
              alt="calenderIcon"
              onClick={changeCalenderState}
            />
            </Tooltip>
          }
        />
      </div>
    </div>
  );
}

export default EditCalendarComponent;
